<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title" v-for="shop in msg">
                {{ shop.alias + ' 營業時間' }} <span class="red">{{ shop.message }}</span>
            </div>
            <div class="subtitle">
                因營業時間可能已結束或即將結束
                <br/>
                可能導致任務無法順利進行
                <br/>
                請問是否仍然要繼續送單
                <br/>
                騎士會照常前往該地點
                <br/>
                <br/>
                ＃營業時間部分來自網路資料
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消送單
            </div>
            <div class="confirm button" @click="onConfirm">
                確定送單
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';

    export default {
        name: 'NotWorkShopModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                display: false,
                msg: [],
            };
        },
        methods: {
            onConfirm() {
                this.display = false;
                this.$emit('onConfirm');
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show(msg) {
                this.display = true;
                this.msg = msg;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: rgba(244,67,54,1);
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
